import { EConsultantCianChatActionTypes, TConsultantCianChatActions } from 'shared/actions/consultantCianChat/actions';

export interface IConsultantCianChatsState {
  requestStatus: 'initial' | 'loading' | 'finished';
  isLoading: boolean;
  isError: boolean;
  isErrorPopupOpened: boolean;
  isEnabled: boolean;
  isOpened: boolean;
  chatId: string | null;
  isAutorisationPopupOpened: boolean;
}

const initialState: IConsultantCianChatsState = {
  requestStatus: 'initial',
  chatId: null,
  isLoading: false,
  isError: false,
  isErrorPopupOpened: false,
  isEnabled: false,
  isOpened: false,
  isAutorisationPopupOpened: false,
};

export function consultantCianChatReducer(
  state: IConsultantCianChatsState = initialState,
  action: TConsultantCianChatActions,
): IConsultantCianChatsState {
  switch (action.type) {
    case EConsultantCianChatActionTypes.OpenAutorisationMotivationPopup:
      return {
        ...state,
        isOpened: false,
        isAutorisationPopupOpened: true,
      };

    case EConsultantCianChatActionTypes.CloseAutorisationMotivationPopup:
      return {
        ...state,
        isOpened: false,
        isAutorisationPopupOpened: false,
      };

    case EConsultantCianChatActionTypes.OpenChat:
      return {
        ...state,
        chatId: action.payload,
        isOpened: true,
        isLoading: false,
        isAutorisationPopupOpened: false,
      };

    case EConsultantCianChatActionTypes.CloseChat:
      return {
        ...state,
        isOpened: false,
        isAutorisationPopupOpened: false,
      };

    case EConsultantCianChatActionTypes.SetChatLoading:
      return {
        ...state,
        isLoading: true,
      };

    case EConsultantCianChatActionTypes.OpenErrorMessage:
      return {
        ...state,
        isError: true,
        isErrorPopupOpened: true,
        isLoading: false,
      };

    case EConsultantCianChatActionTypes.CloseErrorMessage:
      return {
        ...state,
        isErrorPopupOpened: false,
        isAutorisationPopupOpened: false,
      };

    default:
      return state;
  }
}
